<template>
  <div :class="quickSelectorClass" :id="id">
    <h3 class="quick-selector-title first">
      <a @click.prevent="toggle">
        <span>{{ label }}</span> <i :class="chevronClass"></i>
      </a>
    </h3>
    <div class="quick-selector-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Storage from '@/lib/storage.js';
import storedVisibilityMixin, { Visibility } from '@/lib/components/Shared/mixins/stored-visibility-mixin.js';

export default {
  mixins: [storedVisibilityMixin],
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Filters'
    }
  },
  computed: {
    quickSelectorClass() {
      return [
        'quick-selector',
        'ignore',
        this.isOpen ? Visibility.OPEN : Visibility.CLOSED
      ];
    }
  },
  created() {
    this.setInitialVisibility();
  }
};
</script>
